import React from 'react';

import { PropTypes } from 'prop-types';

import { StyledButton } from '../../../styledComponents/styledComponents';
import { DefaultGrey } from '../../../constants/colors';
import BlockSpinner from '../BlockSpinner/BlockSpinner';

function CsvButtonTemplate({ clickHandler, heightInPx, isLoading, inputStyle }) {
   return (
      <StyledButton
         type='button'
         fontSizePx={inputStyle ? 13 : 10.5}
         className={'btn'}
         fixMargin
         name={'csvBtn'}
         id={'csvBtn'}
         heightPx={heightInPx}
         widthPx={inputStyle ? 80 : 60}
         bgColor={inputStyle ? '#fff' : DefaultGrey()}
         fontColor={'black'}
         bgColorHover={isLoading ? (inputStyle ? '#fff' : DefaultGrey()) : inputStyle ? '#f0f3f5' : DefaultGrey(1, 210)}
         fontColorHover={'black'}
         border={inputStyle ? '1px solid #c8ced3' : '1px solid rgba(0,0,0,0.2)'}
         borderRadiusPx={inputStyle ? 4 : undefined}
         onClick={isLoading ? undefined : clickHandler}
         $buttonHeightPx={heightInPx}
         disabled={isLoading}
         $cursor={isLoading ? 'not-allowed' : undefined}
      >
         {isLoading ? (
            <BlockSpinner
               ballSizePx={9}
               ballColor={DefaultGrey(1, 50)}
               paddingTopBottomPx={1}
               widthPx={40}
               heightPx={heightInPx}
            />
         ) : (
            <>{'Get CSV'}</>
         )}
      </StyledButton>
   );
}

CsvButtonTemplate.propTypes = {
   clickHandler: PropTypes.func,
   heightInPx: PropTypes.number,
   isLoading: PropTypes.bool,
   inputStyle: PropTypes.bool,
};

CsvButtonTemplate.defaultProps = {
   heightInPx: 19,
   inputStyle: false,
};

export default CsvButtonTemplate;
